import axios from 'axios';

import { GATEWAY, CONNECTION_TIME_LIMIT } from 'config';


// eslint-disable-next-line require-jsdoc
export default function createHttp() {
  const instance = axios.create({
    baseURL: GATEWAY,
    withCredentials: true,
    timeout: CONNECTION_TIME_LIMIT
  });

  return instance;
}
